import { Injectable } from '@angular/core';
import {HttpService} from '../../core/lib/http.service'
import { OthersService } from '../../services/others/others.service'
import { JsonPipe } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class BillingService {

  apiurl:string = '';

  constructor(private httpservice:HttpService, private otherService:OthersService) { 
    this.apiurl = otherService.getApiUrl();
  }

  getSubPayments(compid) {
    return this.httpservice.get(this.apiurl + '/v3/billing/' + compid + '/payments',[]);   
  }

  getSubPayment(compid,tid) {
    return this.httpservice.get(this.apiurl + '/v3/billing/' + compid + '/payment/' + tid,[]);   
  }

  getTransBySub(sid) {
    return this.httpservice.get(this.apiurl + '/v3/admin/subscription/' + sid + '/trans',[]);   
  }

  getTrans(tid) {
    return this.httpservice.get(this.apiurl + '/v3/admin/trans/' + tid,[]);   
  }

  getPayments(tid) {
    return this.httpservice.get(this.apiurl + '/v3/admin/payments/' + tid,[]);   
  }

  getPayment(id) {
    return this.httpservice.get(this.apiurl + '/v3/admin/payment/' + id,[]);   
  }

  getInvoices(sid,data) {
    return this.httpservice.get(this.apiurl + '/v3/subscription/' + sid + '/invoices',data);   
  }

  getInvoice(compid,no) {
    return this.httpservice.get(this.apiurl + '/v3/billing/' + compid + '/invoice/'+no,[]);   
  }

  getTotalSubscribe(compid) {
    return this.httpservice.get(this.apiurl + '/v3/billing/' + compid +'/count',[]);   
  }

  getSubscribes(data) {
    return this.httpservice.get(this.apiurl + '/v3/admin/subscription',data);  
  }

  getSubscribe(sid) {
    return this.httpservice.get(this.apiurl + '/v3/admin/subscription/' + sid,[]);  
  }

  getCompSubscribes(compid) {
    return this.httpservice.get(this.apiurl + '/v3/billing/' + compid +'/subscribes',[]);  
  }

  getCurrentBilling(sid) {
    return this.httpservice.get(this.apiurl + '/v3/billing/' + sid,[]);   
  }

  getBillingAddress(compid) {
    return this.httpservice.get(this.apiurl + '/v3/billing/' + compid +'/address',[]);  
  }

  getTotalNetwork(compid) {
    return this.httpservice.get(this.apiurl + '/v3/billing/' + compid +'/totalnetwork',[]);   
  }

  updateSubscribe(sid,data) {
    return this.httpservice.post1(this.apiurl + '/v3/admin/subscription/'+sid+'/update',data);  
  }

  updateTrans(tid,data) {
    return this.httpservice.post1(this.apiurl + '/v3/admin/trans/'+tid+'/update',data);  
  }

  updateBillingAddress(compid,data) {
    return this.httpservice.post(this.apiurl + '/v3/billing/' + compid +'/address',data);  
  }

  getPackages(data) {
    return this.httpservice.post(this.apiurl + '/v3/billing/packages/',data);  
  }

  listPackages(data) {
    return this.httpservice.get(this.apiurl + '/v3/admin/packages/',data);  
  }


  makeSubscribe(data) {
    return this.httpservice.post(this.apiurl + '/v3/billing/addsubscribe',data);  
  }

  

  cancelSubscription(data) {
    return this.httpservice.post(this.apiurl + '/v3/billing/cancel',data);  
  }

  renewSubscription(data) {
    return this.httpservice.post(this.apiurl + '/v3/billing/renew',data);  
  }

  changePlan(data) {
    return this.httpservice.post(this.apiurl + '/v3/admin/subscription/setup',data);  
  }


  getNotidy(compid) {
    return this.httpservice.get(this.apiurl + '/v3/billing/' + compid + '/notify',[]);   
  }

  setNotidy(compid,data:object) {
    return this.httpservice.post(this.apiurl + '/v3/billing/' + compid + '/setnotify',data);  
  }
  
}
